/**
 * Datetimepicker używany w wielu miejscach w aplikacji.
 *
 * Korzysta z https://www.daterangepicker.com/
 *
 * @param selector
 * @param ranges
 */
global.activeDaterangePicker = function activeDaterangePicker(selector, ranges) {
    $(selector).daterangepicker({
        'ranges': ranges,
        'showWeekNumbers': true,
        'locale': {
            'format': 'YYYY-MM-DD',
            'separator': ' - ',
            'applyLabel': trans['app.apply_label'],
            'cancelLabel': trans['app.cancel_label'],
            'fromLabel': trans['app.from_label'],
            'toLabel': trans['app.to_label'],
            'customRangeLabel': trans['app.custom_range_label'],
            'weekLabel': 'W',
            'daysOfWeek': [
                trans['app.sun'],
                trans['app.mon'],
                trans['app.tue'],
                trans['app.wed'],
                trans['app.thu'],
                trans['app.fri'],
                trans['app.sat']
            ],
            'monthNames': [
                trans['app.january'],
                trans['app.february'],
                trans['app.march'],
                trans['app.april'],
                trans['app.may'],
                trans['app.june'],
                trans['app.july'],
                trans['app.august'],
                trans['app.september'],
                trans['app.october'],
                trans['app.november'],
                trans['app.december']
            ],
            'firstDay': 1
        },
        'alwaysShowCalendars': true,
        'autoUpdateInput': false,
    }, function (start, end, label) {
        $(selector + '_from').val(start.format('YYYY-MM-DD'))
        $(selector + '_to').val(end.format('YYYY-MM-DD'))
    })

    $(selector).on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD.MM.YYYY') + ' - ' + picker.endDate.format('YYYY-MM-DD'))
        $(selector + '_from').val($(selector).data('daterangepicker').startDate.format('YYYY-MM-DD'))
        $(selector + '_to').val($(selector).data('daterangepicker').endDate.format('YYYY-MM-DD'))
        $(this).trigger('change')
    })

    $(selector).on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('')
        $(selector + '_from').val('')
        $(selector + '_to').val('')
        $(this).trigger('change')
    })

    $(selector).keyup(function () {
        $(selector + '_from').val('')
        $(selector + '_to').val('')
    })

    $(selector).closest('form').find('.btn-clear-form').on('click', function () {
        $(selector + '_from').val('')
        $(selector + '_to').val('')
    })
}

global.activeDatePicker = function activeDatePicker(selector) {
    $(selector).daterangepicker({
        'showWeekNumbers': true,
        'singleDatePicker': true,
        'locale': {
            'format': 'DD-MM-YYYY',
            'separator': ' . ',
            'applyLabel': trans['app.apply_label'],
            'cancelLabel': trans['app.cancel_label'],
            'fromLabel': trans['app.from_label'],
            'toLabel': trans['app.to_label'],
            'customRangeLabel': trans['app.custom_range_label'],
            'weekLabel': 'W',
            'daysOfWeek': [
                trans['app.sun'],
                trans['app.mon'],
                trans['app.tue'],
                trans['app.wed'],
                trans['app.thu'],
                trans['app.fri'],
                trans['app.sat']
            ],
            'monthNames': [
                trans['app.january'],
                trans['app.february'],
                trans['app.march'],
                trans['app.april'],
                trans['app.may'],
                trans['app.june'],
                trans['app.july'],
                trans['app.august'],
                trans['app.september'],
                trans['app.october'],
                trans['app.november'],
                trans['app.december']
            ],
            'firstDay': 1
        },
        'alwaysShowCalendars': true,
        'autoUpdateInput': false,
    }, function (start) {
        $(selector + '_from').val(start.format('YYYY-MM-DD'))
    })

    $(selector).on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD'))
        $(selector + '_from').val($(selector).data('daterangepicker').startDate.format('YYYY-MM-DD'))
        $(this).trigger('change')
    })

    $(selector).on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('')
        $(selector + '_from').val('')
        $(this).trigger('change')
    })

    $(selector).keyup(function () {
        $(selector + '_from').val('')
    })

    $(selector).closest('form').find('.btn-clear-form').on('click', function () {
        $(selector + '_from').val('')
    })
}
